import React, { useState, useEffect } from "react";
import axios from "axios";
import "./NewUpdates.css";
import { Fade } from "react-awesome-reveal";

function NewUpdates() {
  const [updates, setUpdates] = useState([]);
  const [popupData, setPopupData] = useState(null);
  const [loadingMedia, setLoadingMedia] = useState({});
  const currentDate = new Date();

  useEffect(() => {
    fetchUpdates();
  }, []);

  const fetchUpdates = async () => {
    try {
      const res = await axios.get("https://himchatterjee.in/backend/get_updates.php");
      setUpdates(res.data);

      // Initialize loading state for each media
      const initialLoading = {};
      res.data.forEach(update => {
        update.media.forEach(m => {
          initialLoading[m.id] = true;
        });
      });
      setLoadingMedia(initialLoading);

    } catch (err) {
      console.error("Error fetching updates", err);
    }
  };

  const handleMediaLoad = (id) => {
    setLoadingMedia(prev => ({ ...prev, [id]: false }));
  };

  const isNew = (dateString) => {
    const updateDate = new Date(dateString);
    const diffTime = currentDate - updateDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays <= 7;
  };

  const openPopup = (media) => setPopupData(media);
  const closePopup = () => setPopupData(null);

  const getFadeDirection = (index) => {
    if (index === 0) return "left";
    if (index === 1) return "down";
    return "right";
  };

  return (
    <div className="updates-section">
      <Fade direction="down" triggerOnce={false}>
        <h2 className="updates-title">LATEST UPDATES</h2>
      </Fade>

      {updates.map((update, index) => (
        <Fade key={update.id} direction={getFadeDirection(index)} triggerOnce={false}>
          <div className="update-card">
            <h3 className="highlight-heading">{update.heading}</h3>
            <div className="updates-grid">
              {update.media.map((m) => (
                <div key={m.id} className="media-wrapper" onClick={() => openPopup(m)}>
                  <div className="media-container">
                    {/* Loader overlay */}
                    {loadingMedia[m.id] && (
                      <div className="media-loader-overlay">
                        <div className="loader"></div>
                      </div>
                    )}

                    {/* Image / Video */}
                    {m.file_type === "image" ? (
                      <img
                        src={m.file_path}
                        alt={update.heading}
                        onLoad={() => handleMediaLoad(m.id)}
                        style={{ display: loadingMedia[m.id] ? "none" : "block" }}
                      />
                    ) : (
                      <div className="video-thumbnail">
                        <video
                          onLoadedData={() => handleMediaLoad(m.id)}
                          style={{ display: loadingMedia[m.id] ? "none" : "block" }}
                        >
                          <source src={m.file_path} type="video/mp4" />
                        </video>
                        <span className="video-icon">▶</span>
                      </div>
                    )}

                    {isNew(update.created_at) && <span className="badge-new">NEW</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Fade>
      ))}

      {popupData && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={closePopup}>&times;</button>
            {popupData.file_type === "image" ? (
              <img src={popupData.file_path} alt="" />
            ) : (
              <video controls autoPlay>
                <source src={popupData.file_path} type="video/mp4" />
              </video>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default NewUpdates;
